import styled from "styled-components";
import { getDashColor } from '../../styles'
import {
  WHITE,
  PRIMARY_RED_01,
  BLACK,
} from 'bd-web-components/src/utils/dash-colors';

export const Container = styled.div`
  display: flex;
  height: 94px;
  background-color: ${getDashColor('PRIMARY_BLUE_01', 'WHITE')};
  color: #fff;
  padding: 0 32.5px;
  position: fixed;
  z-index: 999;
  width: 100%;
  border-bottom: 1px solid ${getDashColor('GRAY_SCALE_08', 'BEIGE')};

  @media (max-width: 1000px) {
    height: 63px;
    padding: 16px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
`;

export const ImgLogo = styled.img`
  margin-right: 60px;
  width: 100%;
  @media (max-width: 1640px) {
    margin-right: 0;
  }
`;

export const ImgSwitch = styled.img``;

export const VerticalDivider = styled.div`
  width: 4px;
  height: 40px;
  background-color: ${getDashColor('WHITE', 'GRAY_DARK')};
  border-radius: 4px;

  @media (max-width: 1000px) {
    display: none;
  }
`;

export const HalfHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: 1000px) {
    gap: 0rem;
  }
`;

export const ContainerSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const OtherHalf = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
`;

export const MenuOptionContainer = styled.div`
  display: flex;
  gap: 3rem;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const MenuOptionText = styled.a`
  font-weight: 500;
  font-size: 1rem;
`;

export const MenuMobile = styled.a`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 25.2px;
  margin: 0 24px;
  align-items: center;
  display: none;

  & > p {
    margin-right: 10px;
  }

  @media (max-width: 1000px) {
    display: flex;
  }
`;

export const MenuOptionMobile = styled.div`
  position: absolute;
  top: 90%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #E9F4F7;
  background: #FFF;
  box-shadow: 0px 0px 40px 0px rgba(193, 205, 226, 0.28);

  &.right {
    right: 10px;
  }
`;

export const LinkLogo = styled.a`
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const HamburgerIconContainer = styled.div`
  display: none;

  @media (max-width: 1000px) {
    display: block;
    cursor: pointer;
  }
`;

export const HamburgerIcon = styled.img`
  display: block;
`;

export const MenuDesktop = styled.div`
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const Menu = styled.a`
  border-radius: 100px;
  padding: 10px 32px;
  margin-right: 5px;
  cursor: pointer;
  color: ${getDashColor('WHITE', 'GRAY_DARK')};

  @media (max-width: 1000px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    border-radius: 100px;
    width: 100%;
    color: ${getDashColor('GRAY_SCALE_04', 'GRAY_DARK')};

    &.active {
      text-decoration: underline;
    }
  }

  &.active {
    background-color: ${getDashColor('PRIMARY_RED_01', 'GRAY_DARK')};
    color: ${WHITE};
    &:hover {
      color: ${WHITE};
    }
  }

  &:hover {
    color: ${getDashColor('GRAY_SCALE_08', 'GRAY_LIGHT')};
  }
`;

export const MenuButton = styled.div`
  cursor: pointer;
  display: flex;
  width: 90px;
  height: 35px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 110px;
  background: ${WHITE};
  color: ${BLACK};
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 13.6px;
  text-transform: uppercase;
  display: none;

  @media (max-width: 1000px) {
    display: flex;
  }

  &.active {
    background: ${getDashColor('SECONDARY_BLUE_04', 'SECONDARY_COLOR')};
    color: ${WHITE};
  }
`;

export const MenuLink = styled.div`
  padding: 14px 16px;
  color: ${BLACK};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  align-items: center;

  & > p {
    padding: 5px 10px;
  }

  &.logout {
    cursor: pointer;
    color: ${PRIMARY_RED_01};
  }
`;

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_09', 'GRAY_DARK')};
  width: 100%;
  height: 2px;
`
